import { useEffect, useRef, useState } from "react";

/**
 * Gère le cycle de vie d'une modale de confirmation liée à une action asynchrone.
 *
 * @param {Function} action    Action déclenchée à la confirmation.
 * @param {boolean}  isLoading Action en cours : la modale reste ouverte et non fermable,
 *                             puis se ferme quand isLoading retombe.
 */
export default function useConfirmAction(action, isLoading) {
    const [isOpen, setIsOpen] = useState(false);
    const wasLoadingRef = useRef(false);

    useEffect(() => {
        if (wasLoadingRef.current && !isLoading) setIsOpen(false);
        wasLoadingRef.current = isLoading;
    }, [isLoading]);

    const open = () => setIsOpen(true);

    const close = () => {
        if (isLoading) return;
        setIsOpen(false);
    };

    const confirm = () => action();

    return { isOpen, open, close, confirm };
}
